import { render, staticRenderFns } from "./KnowUs.vue?vue&type=template&id=4ca7851c&scoped=true&"
import script from "./KnowUs.vue?vue&type=script&lang=js&"
export * from "./KnowUs.vue?vue&type=script&lang=js&"
import style0 from "./KnowUs.vue?vue&type=style&index=0&id=4ca7851c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca7851c",
  null
  
)

export default component.exports